import { keyframes, alpha, SxProps } from '@mui/material/styles'
import SvgIcon from '@mui/material/SvgIcon'

import Box from '@mui/material/Box'

const dash = keyframes`
  62.5% {
    opacity: 0
  }
  100% {
    stroke-dashoffset: 0
  }
`

export function HeartbeatLoader({ sx = [] }: { sx?: SxProps }) {
  return (
    <Box sx={[{ transform: 'scale(3)' }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <SvgIcon width="16px" height="12px">
        <Box
          component="polyline"
          sx={{
            fill: 'none',
            strokeWidth: 1,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            stroke: (theme) => alpha(theme.palette.primary.main, 0.3),
          }}
          points="1 6 4 6 6 11 10 1 12 6 15 6"
        />
        <Box
          component="polyline"
          sx={{
            fill: 'none',
            strokeWidth: 1,
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            stroke: (theme) => theme.palette.primary.main,
            strokeDasharray: '12, 36', //Dash 12 & Gap 36
            strokeDashoffset: '48',
            animation: `${dash} 1.5s linear infinite`,
          }}
          points="1 6 4 6 6 11 10 1 12 6 15 6"
        />
      </SvgIcon>
    </Box>
  )
}

export default HeartbeatLoader
